export default "__VITE_ASSET__MSGrztmp__"